import { X_AXIS_TIME_TYPE } from "../../../Utils/EnvUtils";

export const AxisBottom = ({
  xScale,
  innerHeight,
  tickFormat,
  tickOffset = 3,
  timeType
}) =>
  xScale.ticks(findTick(timeType)).map((tickValue, i) => (
    <g
      className="tick"
      key={tickValue}
      transform={`translate(${xScale(tickValue)},0)`}
    >
      <line y2={innerHeight} />
      <text
        style={{ textAnchor: "middle" }}
        dy=".71em"
        y={innerHeight + tickOffset}
      >
        {tickFormat(tickValue)}
      </text>
    </g>
  ));

function findTick(timeType) {
  switch (timeType) {
    case X_AXIS_TIME_TYPE.TIME:
      return 24;
      break;
    case X_AXIS_TIME_TYPE.DAY:
      return 31;
      break;
    case X_AXIS_TIME_TYPE.MONTH:
      return 12;
      break;
    default:
      return 24;
      break;
  }
}
